const colors = {
  white: "سفید",
  black: "مشکی",
  red: "قرمز",
  gray: "طوسی",
  green: "سبز",
  blue: "آبی",
  beige: "کرم",
  darkGreen: "سبز تیره",
  brown: "قهوه ای",
  lightBrown: "قهوه ای روشن",
  darkGray: "طوسی تیره",
  navyBlue: "سرمه ای",
  crimson: "زرشکی",
  yellow: "زرد",
  orange: "نارنجی",
  pink: "صورتی",
};
export default colors;
